module.exports = __webpack_public_path__ + "img/school-placeholder.f4825714.jpg";